<div class="container-fluid" style="padding: 20px;">
    <div class="row">
        <div class="col-12">
            <h2>Locked Accounts</h2>
            <p>Accounts that are currently locked due to too many failed login attempts.</p>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <button (click)="loadLockedAccounts()" [disabled]="isLoading" color="primary" mat-raised-button>
                <mat-icon>refresh</mat-icon>
                Refresh
            </button>
        </div>
    </div>

    <div class="row" style="margin-top: 20px;">
        <div class="col-12">
            <div *ngIf="isLoading" style="text-align: center; padding: 20px;">
                <mat-spinner style="margin: 0 auto;"></mat-spinner>
            </div>

            <div *ngIf="!isLoading && lockedAccounts.length === 0" style="text-align: center; padding: 40px;">
                <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: #4caf50;">check_circle</mat-icon>
                <h3>No locked accounts</h3>
                <p>There are currently no accounts locked due to failed login attempts.</p>
            </div>

            <table *ngIf="!isLoading && lockedAccounts.length > 0" [dataSource]="lockedAccounts" class="mat-elevation-z2"
                   mat-table style="width: 100%;">

                <!-- Username Column -->
                <ng-container matColumnDef="username">
                    <th *matHeaderCellDef mat-header-cell>Username</th>
                    <td *matCellDef="let account" mat-cell>{{ account.username }}</td>
                </ng-container>

                <!-- IP Address Column -->
                <ng-container matColumnDef="ipAddress">
                    <th *matHeaderCellDef mat-header-cell>IP Address</th>
                    <td *matCellDef="let account" mat-cell>{{ account.ipAddress }}</td>
                </ng-container>

                <!-- First Attempt Column -->
                <ng-container matColumnDef="firstAttemptAt">
                    <th *matHeaderCellDef mat-header-cell>First Attempt</th>
                    <td *matCellDef="let account" mat-cell>{{ DateUtil.formatDate(account.firstAttemptAt) }}</td>
                </ng-container>

                <!-- Last Attempt Column -->
                <ng-container matColumnDef="lastAttemptAt">
                    <th *matHeaderCellDef mat-header-cell>Last Attempt</th>
                    <td *matCellDef="let account" mat-cell>{{ DateUtil.formatDate(account.lastAttemptAt) }}</td>
                </ng-container>

                <!-- Locked Until Column -->
                <ng-container matColumnDef="lockedUntil">
                    <th *matHeaderCellDef mat-header-cell>Locked Until</th>
                    <td *matCellDef="let account" mat-cell>
                        <span class="badge bg-warning text-dark">{{ DateUtil.formatDate(account.lockedUntil) }}</span>
                    </td>
                </ng-container>

                <!-- Actions Column -->
                <ng-container matColumnDef="actions">
                    <th *matHeaderCellDef mat-header-cell>Actions</th>
                    <td *matCellDef="let account" mat-cell>
                        <button (click)="unlockAccount(account)" color="warn" mat-raised-button>
                            <mat-icon>lock_open</mat-icon>
                            Unlock
                        </button>
                    </td>
                </ng-container>

                <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
                <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
            </table>
        </div>
    </div>
</div>